const sessionStorageForcedFlagKey = 'landrForcedFlags';
const areDevToolsActive = () => !!((window === null || window === void 0 ? void 0 : window.document) && window.__LANDR_DEVTOOLS_HOOKS__);
const sendToDevTools = (name, payload) => {
    window.__LANDR_DEVTOOLS_HOOKS__.emit(name, payload);
};
/**
 * subscribes to specific event from devtools
 * @return destroy method to unsubscribe
 */
const subscribeFromDevTools = (name, callback) => {
    return window.__LANDR_DEVTOOLS_HOOKS__.on(name, callback);
};
const getCachedForcedFlags = (applicationName) => {
    var _a;
    const cachedValue = sessionStorage.getItem(sessionStorageForcedFlagKey);
    const parsedCacheValue = cachedValue ? JSON.parse(cachedValue) : {};
    return (_a = parsedCacheValue[applicationName]) !== null && _a !== void 0 ? _a : {};
};
/**
 * Send an event to LANDR devtools with the initial application details
 */
const setupLandrDevTools = (applicationName, applicationVersion, config) => {
    if (areDevToolsActive()) {
        window.__LANDR_DEVTOOLS_HOOKS__.emit('set-state', {
            name: applicationName,
            version: applicationVersion,
            config: config,
            isLocal: process.env.NODE_ENV !== 'production',
        });
    }
};

export { areDevToolsActive, getCachedForcedFlags, sendToDevTools, setupLandrDevTools, subscribeFromDevTools };
